// Autogenerated from file 'ViewStructs.tt'. DO NOT MODIFY
// =============================================================================
// Yodiwo Library Structs
// =============================================================================
import * as _API from "../API/index";
import { YodiBoardConfiguration } from "./ModelViews";

//----------------------------------------------- 
export module Admin {
  export enum eApp {
    Admin = 0,
    Quota = 1,
    Timeline = 2,
    Report = 3,
    Console = 4,
    AdminDashboard = 5,
    Login = 6
  }
  export enum eFieldType {
    Checkbox = 0,
    TextField = 1,
    Percentage = 2,
    Select = 3,
    Date = 4,
    DateTime = 5,
    Timespan = 6,
    Timespan_OnlyDays = 7
  }
  export enum eQueryType {
    UsersOverLimit = 0,
    UsersOverPercentageInSpecificQuota = 1,
    UsersPerformedSpecificEventWithinTheLastDays = 2,
    QuotaUsage = 3,
    HighTrafficUsers = 4
  }
  export enum eReportFileFormatTypes {
    EXCEL = 0,
    PDF = 1
  }
  export enum eReportModes {

    /**
     * Customer facing report: single file per target user
     */
    CUSTOMER_GENERIC = 0,

    /**
     * Internal report: single file for all requested target users
     */
    INTERNAL = 1,

    /**
     * Customer specific - DialogEK
     */
    CUSTOMER_DIALOGEK = 2
  }
  export enum eReportTemplates {

    /**
     * Yodiwo report template
     */
    YODIWO = 0,

    /**
     * Other templates will be added to host customer-specific requirements
     */
    OTHER = 1
  }
  export enum eServerTypes {
    DEVMIRROR_DEV4 = 0,
    STAGING_TCYAN = 1,
    PRODUCTION_CYAN = 2,
    HAP_DEV8 = 3,
    HAP_DEV11 = 4
  }
  export enum ReportingLevels {
    RL_COMPACT = 0,
    RL_FULL = 1
  }
  export interface AccountServerPair {
    Server: Admin.eServerTypes;
    User: string;
  }
  export interface ActivityReport {
    LeastActive: { [key: string]: number };
    MostActive: { [key: string]: number };
  }
  export interface ActivityReportReq {
    EndDate: Date;
    HighActivityThreshold: number;
    LowActivityThreshold: number;
    MetricType: _API.Warlock.eQuotaType;
    StartDate: Date;
  }
  export interface AdminAppsRsp extends WebApps.CommonGenericRsp {
    Apps: Admin.eApp[];
    UserDescriptor: any;
  }
  export interface AdminDashboardQuotaReq {
    NodeKey: string;
    UserKey: any;
  }
  export interface AdminQueryReq {
    Fields: { [key: string]: string };
    ID: string;
  }
  export interface AdminQueryRsp extends WebApps.CommonGenericRsp {

    /**
     * Column name for additional info
     */
    AdditionalInfoName: string;

    /**
     * Event Name -> miliseconds timestamp, info
     */
    Events: { [key: string]: { Item1: string, Item2: string }[] };

    /**
     * True if query it's about quota report
     */
    IsUsageReport: boolean;

    /**
     * Timeseries dataset containing percentages (percentage scales data values)
     */
    Percentages: Admin.TimeseriesDataset;

    /**
     * Events Recorded
     */
    TimelineDescriptors: any[];

    /**
     * Beyond user descriptor, additional info to be diplayed
     */
    UserKey2AdditionalInfo: { [key: string]: string };

    /**
     * List of userkeys matching the query
     */
    UserKeys: string[];
    UserQuotaDescriptor: any;
  }
  export interface AdminRoutes {
  }
  export interface FieldInfo {
    FieldId: string;
    FieldName: string;
    FieldType: Admin.eFieldType;
    Options: { [key: string]: string };
    Value: string;
  }
  export interface FileReportParameters extends Yodiwo.Web.Library.ModelViews.ReportParametersDialog {
    EndDate: Date;
    ExportedFileFormats: Admin.eReportFileFormatTypes[];
    ExportedFilenamePrefix: string;
    Server: Admin.eServerTypes;
    StartDate: Date;
    TargetUser: string;
    Template: Admin.eReportTemplates;
  }
  export interface GeneratedFileReports {
    ReportLinks: { [key: string]: { [key: string]: string } };
  }
  export interface GenerateFileReportReq {
    FileReportParams: Admin.FileReportParameters[];
    Mode: Admin.eReportModes;
  }
  export interface QueryInfo {
    Description: string;
    Fields: Admin.FieldInfo[];
    ID: string;
    Name: string;
  }
  export interface QuotaReportReq {
    EndDate: Date;
    IncludeAllQuotaTypes: boolean;
    IncludeAllUsers: boolean;
    QuotaType: _API.Warlock.eQuotaType;
    ReportingLevel: Admin.ReportingLevels;
    StartDate: Date;
    TargetUsers: string[];
  }
  export interface StorageReportReq {
    TargetUsers: Admin.AccountServerPair[];
  }
  export interface TimeseriesDataset {

    /**
     * Values' names
     */
    ColumnNames: string[];

    /**
     * Milisecond timestamp to values. (May contain NaN values)
     */
    TimeToValues: { [key: number]: number[] };
  }
}
//----------------------------------------------- 
export module AppDomainLogin {
  export interface GetLoginInfoRsp extends WebApps.CommonGenericRsp {
    AppDomainMgrUrl: string;
    AppDomains: any[];
    Domain: string;
  }
}
//----------------------------------------------- 
export module AppDomainMgr {
  export interface AddApplicationReq {
    AppDomainID: string;
    Description: string;
    Tld: string;
  }
  export interface AddApplicationRsp extends WebApps.CommonGenericRsp {
    AppDomainID: string;
  }
  export interface AddDomainUserReq {

    /**
     * If defined, it is used for quick assigning of view access to current application
     */
    AppDomainID: string;
    Email: string;

    /**
     * If set, and caller has adequate rights, a new Top Level account will be provisioned
     */
    IsTopLevelTenant: boolean;
  }
  export interface AppDomainMgrRoutes {
  }
  export interface GetApplicationReq {

    /**
     * If not defined it will fetch all applications
     */
    AppDomainID: string;
  }
  export interface GetApplicationRsp extends WebApps.CommonGenericRsp {
    AppDomains: any[];
  }
  export interface GetDomainUserReq {

    /**
     * Optional explicit Application Domain ID
     */
    AppDomainID: string;

    /**
     * Optional explicit user e-mail
     */
    Email: string;

    /**
     * Whether to fetch users rights or not.
     */
    ParseRights: boolean;
    Tld: string;
  }
  export interface GetUserInfoRsp extends WebApps.CommonGenericRsp {
    CanAddApplications: boolean;
    CanAddUsers: boolean;
    CanDeleteUsers: boolean;
    CanEditUsers: boolean;
    CanMoveAssets: boolean;
    CanSeeUsers: boolean;
    ConnectedTlds: string[];
    Email: string;
  }
  export interface GetUserRsp extends WebApps.CommonGenericRsp {
    Users: any[];
  }
  export interface RemoveApplicationReq {
    AppDomainID: string;
  }
  export interface RemoveDomainUserReq {

    /**
     * If defined, it is used for quick unassigning of view access to current application
     */
    AppDomainID: string;
    Email: string;

    /**
     * If set, and caller has adequate rights, the Top Level account will be removed
     */
    IsTopLevelTenant: boolean;
  }
  export interface SetDefaultApplicationReq {
    AppDomainID: string;
    RemoveDefault: boolean;
  }
}
//----------------------------------------------- 
export module DashboardStructs {
  export enum CyanServers {
    TCyan = 0,
    Cyan = 1,
    Localhost = 2,
    Dev4Cyan = 3,
    Dev6Cyan = 4,
    Dev5Cyan = 5
  }
  export interface DashboardFile {
    Dashboards: { [key: string]: DashboardStructs.DashboardView };
    Description: string;
    FormatVersion: string;
    Key: string;
    MagicCode: string;
    Name: string;
    NodeKey: string;
    Revision: number;
    WebModuleKey: string;
  }

  /**
   * Alias for _API.Warlock.GenericRsp
   */
  export interface DashboardGenericResp {
    ErrorMsg: string;
    Success: boolean;
  }
  export interface DashboardGetResp {
    Dashboards: DashboardStructs.DashboardList[];
    ErrorMsg: string;
    Success: boolean;
  }
  export interface DashboardHellIncident {
    DashboardKey: string;
    PlegmaDescriptor: any;

    /**
     * used only on load
     */
    PublicID?: string;
    UserId: string;
  }
  export interface DashboardHellLoadReq {
    FromDate?: Date;
    ToDate?: Date;
  }
  export interface DashboardHellLoadResp extends DashboardStructs.DashboardGenericResp {
    Incidents: DashboardStructs.DashboardHellIncident[];
  }
  export interface DashboardHellSaveReq {
    Incidents: DashboardStructs.DashboardHellIncident[];
  }
  export interface DashboardHellSaveResp extends DashboardStructs.DashboardGenericResp {
  }
  export interface DashboardList {
    Description: string;
    Key: string;
    Name: string;
    Revision: number;
  }
  export interface DashboardLoadResp {
    Dashboard: DashboardStructs.DashboardFile;
    DashboardExist: boolean;
    ErrorMsg: string;
    Success: boolean;
  }
  export interface DashboardSaveReq extends DashboardStructs.DashboardFile {
  }
  export interface DashboardSaveResp extends DashboardStructs.DashboardGenericResp {
  }
  export interface DashboardStatics {
    __DASHBOARD_FORMAT_VERSION__: string;
    __MagicCode__: string;
    __STORAGE_KEY_LOGIN__: string;
    __STORAGE_VERSION__: string;
  }
  export interface DashboardView {

    /**
     * The JSON form of dashboard settings.
     */
    JsonDashboardSettings: string;

    /**
     * The json form of widgets
            The server (C#) can't deserialized the widgets
     */
    JsonViewWidgets: string;

    /**
     * Each dashboard view have a unique key
     */
    Key: string;

    /**
     * The timestamp of the last modification
     */
    Timestamp: Date;

    /**
     * Each dashboard have assigned a unique WebModule 
            that is handling the widgets as things
     */
    WebModuleKey: string;
  }
  export interface ImportYodiBoard {
    Description: string;
    Id: string;
    Name: string;
    Pages: DashboardStructs.ImportYodiPage[];
  }
  export interface ImportYodiPage {
    CommonYodiPageSelector: string;
    CurrentYodiPage: boolean;
    IsCommon: boolean;
    Page: DashboardStructs.YodiPage;
    WillImport: boolean;
  }
  export interface MacroInfo {

    /**
     * The connection string for the query.
            This is valid only in design mode.
     */
    ConnectionString: string;

    /**
     * The developer that have make the change
     */
    Developer: string;

    /**
     * Macro is active
     */
    Enabled: boolean;

    /**
     * Macro guid
     */
    Guid: string;

    /**
     * Script to handling results from server
     */
    JsHandlingScript: string;

    /**
     * Script for preparation of parameters
     */
    JsPrepScript: string;

    /**
     * Macro type MySQL, Influx, Rest ...
     */
    MacroType: Macros.MacroScriptType;

    /**
     * Script that the server is going to run.
            This is valid only in design mode.
     */
    QueryScript: string;

    /**
     * Settings for the json
     */
    SettingsJson: string;

    /**
     * Last modify timestamp
     */
    Timestamp: Date;

    /**
     * Macro version
     */
    Version: number;
  }
  export interface PublicSharing {
    Enabled: boolean;
    PublicKey: string;
  }
  export interface YodiBoard {
    CyanServer: DashboardStructs.CyanServers;
    Description: string;
    FormatVersion: string;
    Id: string;
    IsDomainShared: boolean;
    IsEditable: boolean;
    IsShareable: boolean;
    IsUserOwner: boolean;

    /**
     * Json form of json alerts for the specific board
     */
    JsonAlerts: string;

    /**
     * Json form of localization of the board
     */
    JsonLocalization: string;

    /**
     * YodiBoard settings
            JSON string of a  object.
     */
    JsonSettings: string;

    /**
     * Theme in json format
     */
    JsonTheme: string;
    LastModify: Date;

    /**
     * List with active macros of the board
     */
    Macros: DashboardStructs.MacroInfo[];
    Name: string;
    NodeKey: string;

    /**
     * This is valid only in loading time
     */
    NodeSecret: string;

    /**
     * Number of decorative widgets
     */
    NumberOfDecorativeWidgets: number;

    /**
     * Number of non-decorative widgets
     */
    NumberOfNonDecorativeWidgets: number;
    OwnerEmail: string;

    /**
     * This is not valid in basic loading
     */
    Pages: DashboardStructs.YodiPage[];

    /**
     * Public Sharing info.
            If is null then we don't support it
     */
    PublicSharing: DashboardStructs.PublicSharing;

    /**
     * this is valid only in loading time
     */
    WebModuleKey: string;
  }
  export interface YodiBoardAddReq extends DashboardStructs.YodiBoard {
  }
  export interface YodiBoardAddResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardGetMacroHistoryReq {

    /**
     * The ID of the yodiboard that we need the macro history
     */
    BoardId: string;

    /**
     * Macro guid
     */
    Guid: string;
  }
  export interface YodiBoardGetMacroHistoryResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    History: DashboardStructs.MacroInfo[];
  }
  export interface YodiBoardGetPublicSharingReq extends DashboardStructs.YodiBoardPublicSharingInfo {
  }
  export interface YodiBoardGetPublicSharingResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
    ServersInfo: { [key: number]: WebApps.CyanServerInfo };
  }
  export interface YodiBoardGetResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    MyBoards: DashboardStructs.YodiBoard[];
    MyDomainBoards: DashboardStructs.YodiBoard[];
    SharedBoards: DashboardStructs.YodiBoard[];
  }
  export interface YodiBoardGetSharedListReq {
    Id: string;
  }
  export interface YodiBoardGetSharedListResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Info: DashboardStructs.YodiBoardUserInfo[];
  }
  export interface YodiBoardGetVersionsReq {
  }
  export interface YodiBoardGetVersionsResp extends Yodiwo.Web.Library.ModelViews.GenericResp {

    /**
     * Note: These `YodiBoard` instances do not contain all the information, only the needed for the version change check.
     */
    Boards: DashboardStructs.YodiBoard[];
  }
  export interface YodiBoardImportReq {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardImportResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardLoadDeletedResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Pages: DashboardStructs.YodiPage[];
  }
  export interface YodiBoardLoadReq {
    Id: string;

    /**
     * Load the board in view mode 
            Avoid the sending of macros sql info
     */
    IsViewMode: boolean;

    PagesVersions: {
      Id: string,
      Version: number,
      Deleted: boolean
    }[];

    MacrosVersions: {
      Guid: string,
      Version: number,
      Enabled: boolean
    }[];
  }
  export interface YodiBoardLoadResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardPublicSharingInfo {
    BoardId: string;
    PublicKey: string;
  }
  export interface YodiBoardSaveReq {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardSaveResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Id: string;

    /**
     * Note: These `YodiPage` instances do not contain all the information, only `Id` and `Version` fields are valid.
     */
    Pages: DashboardStructs.YodiPage[];
  }
  export interface YodiBoardSetSharedListReq {
    BoardId: string;
    Info: DashboardStructs.YodiBoardUserInfo[];
  }
  export interface YodiBoardSetSharedListResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Info: DashboardStructs.YodiBoardUserInfo[];
  }
  export interface YodiBoardUpdateConfReq extends DashboardStructs.YodiBoard {
  }
  export interface YodiBoardUpdateConfResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
    Board: DashboardStructs.YodiBoard;
  }
  export interface YodiBoardUpdateLocalizationReq {

    /**
     * The ID of the yodiboard that we update localization
     */
    BoardId: string;

    /**
     * The localization dictionary in json format
     */
    JsonLocalization: string;
  }
  export interface YodiBoardUpdateLocalizationResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
  }
  export interface YodiBoardUpdateMacroReq {

    /**
     * The ID of the yodiboard that we update localization
     */
    BoardId: string;

    /**
     * Deleted macros
     */
    DeleteMacro: DashboardStructs.MacroInfo[];

    /**
     * Updated macros
     */
    UpdateMacro: DashboardStructs.MacroInfo[];
  }
  export interface YodiBoardUpdateMacroResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
  }
  export interface YodiBoardUpdatePagesReq {

    /**
     * The ID of the yodiboard that we update pages
     */
    BoardId: string;

    /**
     * List with pages that we request delete
     */
    DeletedPagesID: string[];

    /**
     * The localization dictionary in json format
     */
    JsonLocalization: string;

    /**
     * List with pages that we request undelete
     */
    UndeletePages: string[];

    /**
     * List with updated pages
     */
    UpdatedPages: DashboardStructs.YodiPage[];
  }
  export interface YodiBoardUpdateThemeReq {

    /**
     * The ID of the yodiboard that we update theme
     */
    BoardId: string;

    /**
     * JSON theme
     */
    ThemeJson: string;
  }
  export interface YodiBoardUpdateThemeResp extends Yodiwo.Web.Library.ModelViews.GenericResp {
  }
  export interface YodiBoardUserInfo {
    FromDB: boolean;
    IsDomainShared: boolean;
    IsEditable: boolean;
    IsOwner: boolean;
    IsPending: boolean;
    IsShareable: boolean;
    UserDomain: string;
    UserEmail: string;
    UserId: string;
    YodiBoardId: string;
  }
  export interface YodiPage {
    Deleted: boolean;
    Id: string;
    JsonDashboardSettings: string;
    JsonViewWidgets: string;
    Timestamp: Date;
    Version: number;
    WebModuleKey: string;
  }
}
//----------------------------------------------- 
export module DocumentationEditor {
  export enum eDocumentationCategory {
    Block = 0,
    CyanUI = 1
  }
  export interface DocEditorAddReq {
    Descriptor: DocumentationEditor.DocumentationDescriptor;
  }
  export interface DocEditorAddRsp extends WebApps.CommonGenericRsp {
    ID: string;
  }
  export interface DocEditorChangeReq {
    Descriptor: DocumentationEditor.DocumentationDescriptor;
    ID: string;
  }
  export interface DocEditorFetchReq {
    All: boolean;
    ID: string;
  }
  export interface DocEditorFetchRsp extends WebApps.CommonGenericRsp {
    Descriptors: DocumentationEditor.DocumentationDescriptor[];
  }
  export interface DocEditorRemoveReq {
    ID: string;
  }
  export interface DocEditorRoutes {
  }
  export interface DocumentationDescriptor {
    Content: string;
    ContentCategory: DocumentationEditor.eDocumentationCategory;
    ContentType: _API.Warlock.eDocumentationContentType;
    ID: string;
    ImageSrc: string;
    IsVisible: boolean;
    Name: string;
  }
}
//----------------------------------------------- 
export module Frontend {
  export interface ImpactWizardAddEndpointReq {
    ImpactEndpointCreateReq: any;
    ReRegister: boolean;
  }
  export interface ImpactWizardAddEndpointRsp extends WebApps.CommonGenericRsp {
    ImpactKey: string;
  }
  export interface ImpactWizardAddGroupReq {
    ImpactGroupCreateReq: any;
    ReRegister: boolean;
  }
  export interface ImpactWizardAddGroupRsp extends WebApps.CommonGenericRsp {
    ImpactKey: string;
  }
  export interface ImpactWizardFetchDescriptorsReq {
    FetchAll: boolean;
    Groups: boolean;
    ImpactKey: string;
  }
  export interface ImpactWizardFetchDescriptorsRsp extends WebApps.CommonGenericRsp {
    ImpactDescriptors: any[];
  }
  export interface ImpactWizardFetchSubscriptionsAndResourcesReq {
    ImpactKey: string;
    SkipResources?: boolean;
  }
  export interface ImpactWizardFetchSubscriptionsAndResourcesRsp extends WebApps.CommonGenericRsp {
    ResourcePaths: { [key: string]: string[] };
    SubscriptionsPaths: string[];
  }
  export interface ImpactWizardGetGroupImpactKeyReq {
    GroupName: string;
  }
  export interface ImpactWizardGetGroupImpactKeyRsp extends WebApps.CommonGenericRsp {
    ImpactKey: string;
  }
  export interface ImpactWizardReListEndpointReq {
    ImpactKey: string;
  }
  export interface ImpactWizardRoutes {
  }
  export interface ImpactWizardUpdateSubscriptionsReq {
    ImpactKey: string;
    ResourcePaths: string[];
  }
  export interface UserLoginReq {
    Email: string;
    IsDemoLogin: boolean;
    Name: string;
    PasswordHash: string;
    RememberMe: boolean;
  }
  export interface UserLoginRsp extends WebApps.CommonGenericRsp {
    Redirect: string;
    UserDescriptor: any;
  }
}
//----------------------------------------------- 
export module LoRa {
  export interface AddLoRaApplicationReq {
    Application: any;
    Overwrite: boolean;
  }
  export interface AddOrUpdateLoRaDeviceReq {
    Device: any;
  }
  export interface GetLoRaApplicationReq {
    ApplicationEui: string;
  }
  export interface GetLoRaApplicationRsp extends WebApps.CommonGenericRsp {
    Application: any;
  }
  export interface GetLoRaApplicationsRsp extends WebApps.CommonGenericRsp {
    Applications: any[];
  }
  export interface GetLoRaDeviceReq {
    DeviceEui: string;
  }
  export interface GetLoRaDeviceRsp extends WebApps.CommonGenericRsp {
    Device: any;
  }
  export interface GetLoRaDevicesRsp extends WebApps.CommonGenericRsp {
    Devices: any[];
  }
  export interface LoRaRestPaths {
  }
}
//----------------------------------------------- 
export module Macros {
  export enum MacroScriptType {
    RestAPI = 1,
    MySQL = 2,
    Influx = 3,
    Javascript = 4,
    Flux = 5
  }
  export interface ExecuteSQLReq {

    /**
     * Inline connection string for development phase
     */
    ConnectionStr?: string;

    /**
     * The id of the saved Macro, null if is not saved yet (design phase)
     */
    MacroID?: string;

    /**
     * The version of macro that we are going to execute
     */
    MacroVersion?: number;

    /**
     * An id for the project that is include this macro.
            This is per application id and is something that the external project define.
     */
    ProjectID: string;

    /**
     * The actual query
     */
    Query?: string;

    /**
     * The parameters of the query
     */
    QueryParameters: System.Collections.Generic.KeyValuePair<string, any>[][];
  }
  export interface ExecuteSQLResp extends Yodiwo.Web.Library.ModelViews.GenericResp {

    /**
     * Results in string json format
     */
    JsonResults: string[];
  }
  export interface MacroStatisticsData {
    AvgProcessingTime: number;
    AvgReadData: number;
    NumberOfCall: number;
    TotalProcessingTime: number;
    TotalReadData: number;
  }
  export interface MacroStatisticsReq {

    /**
     * Select the target project
     */
    ProjectID: string;
  }
  export interface MacroStatisticsResp extends Yodiwo.Web.Library.ModelViews.GenericResp {

    /**
     * Results in string json format
     */
    Statistics: Macros.MacroStatisticsData[];
  }
  export interface ServerAutoParameters {
  }
}
//----------------------------------------------- 
export module Schedule {
  export interface ScheduleRoutes {
  }
}
//----------------------------------------------- 
export module Sigfox {
  export interface SigfoxRestPaths {
  }
}
//----------------------------------------------- 
export module System.Collections.Generic {
  export interface KeyValuePair<TKey, TValue> {
    Key: TKey;
    Value: TValue;
  }
}
//----------------------------------------------- 
export module TableModelView {
  export enum AssociationType {
    Auto = 0,
    OneToOne = 1,
    OneToMany = 2,
    ManyToOne = 3
  }
  export enum eSQLServerQueryOperator {
    Equal = 0,
    NotEqual = 1,
    Greater = 2,
    GreaterOrEqual = 3,
    NotGreater = 4,
    Less = 5,
    LessOrEqual = 6,
    NotLess = 7,
    Like = 8,
    Between = 9,
    IsNull = 10,
    IsNotNull = 11
  }
  export enum QueryType {
    Select = 0,
    Delete = 1,
    Update = 2,
    Insert = 3,

    /**
     * Not supported
     */
    InsertOrUpdate = 4,

    /**
     * Not implemented
     */
    CreateTable = 5
  }
  export interface DBColumnInfo {
    ColumnName: string;
    ColumnSchema: any;
    ColumnType: string;
    DataType: string;
    Description: string;
    ForeignKeys: string[];
    IsIdentity: boolean;
    IsNullable: boolean;
    IsPrimaryKey: boolean;
    Length: number;
    MemberName: string;
    Precision: number;
    PrimaryKeyOrder: number;
    Scale: number;
    SkipOnInsert: boolean;
    SkipOnUpdate: boolean;
    Type: string;
  }
  export interface DBInfo {
    DatabaseName: string;
    DataContextName: string;
    DataSource: string;
    ServerVersion: string;
    Tables: { [key: string]: TableModelView.DBTableInfo };
  }
  export interface DBTableInfo {

    /**
     * `ColumnName` to `DBColumnInfo`
     */
    Columns: { [key: string]: TableModelView.DBColumnInfo };
    DataContextPropertyName: string;
    Description: string;

    /**
     * `KeyName` to `ForeignKey`
     */
    ForeignKeys: { [key: string]: TableModelView.ForeignKey };
    ID: string;
    IsProviderSpecific: boolean;
    IsView: boolean;
    Schema: string;
    TableName: string;
    TableSchema: any;
    TypeName: string;
  }
  export interface ForeignKey {
    AssociationType: TableModelView.AssociationType;
    BackReference: TableModelView.ForeignKey;
    CanBeNull: boolean;
    KeyName: string;
    MemberName: string;
    OtherColumns: TableModelView.DBColumnInfo[];
    OtherTable: TableModelView.DBTableInfo;
    OtherTableID: string;
    ThisColumns: TableModelView.DBColumnInfo[];
  }
  export interface SQLServerInfo {
    Database: string;
    Password: string;
    Server: string;
    UserId: string;
  }
  export interface SQLServerQueryColumn {

    /**
     * Column's name
     */
    ColumnName: string;

    /**
     * Table's id that owns column
     */
    TableID: string;
  }
  export interface SQLServerQueryConditionGroup {

    /**
     * Whether to apply 'NOT' logical operator at all rules or not.
     */
    IsNot: boolean;

    /**
     * Whether to group rules using 'OR' or 'AND' logical operators
     */
    IsOr: boolean;

    /**
     * Group's rules
     */
    Rules: TableModelView.SQLServerQueryConditionRule[];

    /**
     * Group's subgroups
     */
    Subgroups: TableModelView.SQLServerQueryConditionGroup[];
  }
  export interface SQLServerQueryConditionRule {

    /**
     * (Required) Left operand. It represents a column.
     */
    Left: TableModelView.SQLServerQueryColumn;

    /**
     * (Required) Operation
     */
    Operator: TableModelView.eSQLServerQueryOperator;

    /**
     * Optional if  is defined.
     */
    Right: TableModelView.SQLServerQueryColumn;

    /**
     * Optional if  is defined.
     */
    Value: any;
  }
  export interface SQLServerQueryReq {

    /**
     * Used only in
     */
    Columns?: TableModelView.SQLServerQueryColumn[];

    /**
     * Used in ,  actions.
            `ColumnName` to new value
     */
    NewColumns?: { [key: string]: string };

    /**
     * (Required) Query type
     */
    QueryType: TableModelView.QueryType;

    /**
     * Used in ,  ,  and  actions.
            (in  is used as fallback if not columns are provided )
     */
    TableID?: string;
    Token: any;

    /**
     * Where conditions
     */
    Where?: TableModelView.SQLServerQueryConditionGroup[];
  }
  export interface SQLServerQueryRsp extends WebApps.CommonGenericRsp {

    /**
     * Whether the results  contain a JArray or not.
     */
    IsJSONString: boolean;

    /**
     * Query results
     */
    Results: string;
  }
  export interface SQLServerSetupReq {
    Info: TableModelView.SQLServerInfo;
  }
  export interface SQLServerSetupRsp extends WebApps.CommonGenericRsp {
    DBInfo: TableModelView.DBInfo;
    Token: any;
  }
}
//----------------------------------------------- 
export module ThingOfMe {
  export enum eHttpMethod {
    Get = 0,
    Post = 1,
    Put = 2
  }
  export enum eThingOfMeDataGeneration {
    KB0 = 0,
    KB10 = 1,
    KB20 = 2,
    KB30 = 3,
    KB40 = 4,
    KB50 = 5,
    KB60 = 6,
    KB70 = 7,
    KB80 = 8
  }
  export enum eThingOfMeDataSourceType {
    Temperature_Sensor = 0,
    Humidity_Sensor = 1,
    Pollution_Sensor = 2,
    EnergyMeter = 3,
    WaterMeter = 4,
    SoundMeter = 5,
    Database = 6,
    External_HTTP_Service = 7,
    Other = 8
  }
  export enum eThingOfMeSensorProtocolType {
    LoRa = 0,
    NB_IOT = 2,
    Other = 100
  }
  export interface ThingOfMeAddDeviceReq extends ThingOfMe.ThingOfMeDevice {
    Routes: string[];
  }
  export interface ThingOfMeAddDeviceRsp extends WebApps.CommonGenericRsp {
    DeviceId: string;
  }
  export interface ThingOfMeCreatePaymentReq {
    Transactions: ThingOfMe.ThingOfMeTransaction[];
  }
  export interface ThingOfMeCreatePaymentRsp extends WebApps.CommonGenericRsp {
    paymentID: string;
  }
  export interface ThingOfMeDevice {
    ConnectionSettingsJson: string;
    DataGeneration: ThingOfMe.eThingOfMeDataGeneration;
    DataSourceType: ThingOfMe.eThingOfMeDataSourceType;
    DataSourceTypeStr: string;
    Exclusive: boolean;

    /**
     * Maintanance fee. Not set from UI.
     */
    Fee: number;
    From: Date;
    Id: string;
    Lat: number;
    Lng: number;
    Name: string;

    /**
     * Filled only when requester owns this datasource
     */
    NumberOfSharees?: number;

    /**
     * Whether user owns o r
     */
    Owned: boolean;
    Price: number;
    ProtocolType: ThingOfMe.eThingOfMeSensorProtocolType;
    RuleFile: string;
    RuleType: string;
    StoreData: boolean;
  }
  export interface ThingOfMeDeviceDatabaseConnectionSettings {
    SqlScript: string;
    SQLServerInfo: TableModelView.SQLServerInfo;
  }
  export interface ThingOfMeExecutePaymentCancelReq {
    billingID: string;
    cancelUrl: string;
    intent: string;
    paymentID: string;
    paymentToken: string;
  }
  export interface ThingOfMeExecutePaymentCancelRsp extends WebApps.CommonGenericRsp {
  }
  export interface ThingOfMeExecutePaymentReq {
    intent: string;
    orderID: string;
    payerID: string;
    paymentID: string;
    paymentToken: string;
    returnUrl: string;
  }
  export interface ThingOfMeExecutePaymentRsp extends WebApps.CommonGenericRsp {
  }
  export interface ThingOfMeFetchDevicesRsp extends WebApps.CommonGenericRsp {
    Devices: ThingOfMe.ThingOfMeDevice[];
  }
  export interface ThingOfMeQueryDecoderTypesReq {
    DataSourceType: ThingOfMe.eThingOfMeDataSourceType;
    DataSourceTypeStr: string;
    ProtocolType: ThingOfMe.eThingOfMeSensorProtocolType;
  }
  export interface ThingOfMeQueryDecoderTypesRsp extends WebApps.CommonGenericRsp {
    Types: { [key: string]: string };
  }
  export interface ThingOfMeQueryDevicesReq {
    DataGeneration: ThingOfMe.eThingOfMeDataGeneration;
    From: Date;
    Lat: number;
    Lng: number;
    Price: number;
    Type: ThingOfMe.eThingOfMeDataSourceType;
  }
  export interface ThingOfMeQueryDevicesRsp extends WebApps.CommonGenericRsp {
    Devices: ThingOfMe.ThingOfMeDevice[];
  }
  export interface ThingOfMeRemoveDeviceReq {
    DeviceId: string;
    Unshare: boolean;
  }
  export interface ThingOfMeRemoveDeviceRsp extends WebApps.CommonGenericRsp {
  }
  export interface ThingOfMeRoutes {
  }
  export interface ThingOfMeTransaction {
    Amount: ThingOfMe.ThingOfMeTransactionAmount;
    Description?: string;
  }
  export interface ThingOfMeTransactionAmount {
    Currency?: string;
    Details?: ThingOfMe.ThingOfMeTransactionAmountDetails;
    Total: string;
  }
  export interface ThingOfMeTransactionAmountDetails {
    GiftWrap?: string;
    HandlingFee?: string;
    Insurance?: string;
    Shipping?: string;
    ShippingDiscount?: string;
    Subtotal?: string;
    Tax?: string;
  }
  export interface ThingOfMeUseDeviceReq {
    DeviceId: string;
    PaymentReq: ThingOfMe.ThingOfMeExecutePaymentReq;
    Routes: string[];
  }
  export interface ThingOfMeUseDeviceRsp extends WebApps.CommonGenericRsp {
  }
  export interface ThingOfMeUserRoute {
    Headers: { [key: string]: string };
    Id: string;
    Method: ThingOfMe.eHttpMethod;
    Name: string;
    Route: string;
    Secure: boolean;
  }
  export interface ThingOfMeUserRoutesAddOrUpdateReq {
    Route: ThingOfMe.ThingOfMeUserRoute;
  }
  export interface ThingOfMeUserRoutesAddOrUpdateRsp extends WebApps.CommonGenericRsp {
  }
  export interface ThingOfMeUserRoutesDeleteReq {
    RouteId: string;
  }
  export interface ThingOfMeUserRoutesDeleteRsp extends WebApps.CommonGenericRsp {
  }
  export interface ThingOfMeUserRoutesFetchRsp extends WebApps.CommonGenericRsp {
    Routes: ThingOfMe.ThingOfMeUserRoute[];
  }
}
//----------------------------------------------- 
export module WebApps {
  export enum DomainUserRole {
    User = 0,
    Developer = 1,
    Admin = 2
  }
  export interface AppInfoView {
    Description: string;
    ImageThumbnail: string;
    Name: string;
    Title: string;
  }
  export interface AppInfoViewResp {
    Apps: WebApps.AppInfoView[];
  }
  export interface AvatarInfoView {
    Large: string;
    Normal: string;
    Small: string;
  }
  export interface CommonGenericRsp {

    /**
     * Whether the request was executed successfully or not
     */
    IsSuccess: boolean;

    /**
     * Message
     */
    Message: string;
  }
  export interface CyanServerInfo {
    CyanURL: string;
    Id: number;
    Name: string;
    URL: string;
    WebSocketURL: string;
  }
  export interface DomainBoardInfo {
    BoardId: string;
    NodeKey: string;
    BoardThemeJSON: string;
    BoardSettingsJSON: string;
    BoardSettings: YodiBoardConfiguration;
  }
  export interface CookiesConsentInfo {
    description: string;
    moreInfo: string;
  }
  export interface DomainInfo {
    UserRole: WebApps.DomainUserRole;
    IsOneBoardSolution: boolean;
    PredefinedLoadingBoardInfo: WebApps.DomainBoardInfo;
    CookiesJSON: string;
  }
  export interface UserInfoResp {
    DomainInfo: WebApps.DomainInfo;
    LoggedIn: boolean;
    ServersInfo: { [key: number]: WebApps.CyanServerInfo };
    Settings: WebApps.UserSettings;
    UserInfo: WebApps.UserInfoView;
  }
  export interface UserInfoView {
    AvatarUri: WebApps.AvatarInfoView;
    Domain: string;
    Email: string;
    FirstName: string;
    LastName: string;
  }
  export interface UserSettings {
    DefaultLoadingBoardId: string;
  }
}
//----------------------------------------------- 
export module Yodiwo.Web.Library.ModelViews {
  export interface GenericResp {
    ErrorStr: string;
    IsSuccess: boolean;
  }
  export interface ReportParametersDialog {
    Constraints: { [key: string]: string[] };
  }
}

